import { useEffect, useState } from "react";
import { History, ArrowRight } from "lucide-react";
import { api, formatARS } from "@/lib/api";

const SOURCE_LABEL = { manual: "Edición manual", xlsx: "Lista Excel", csv: "Lista CSV", pdf: "Lista PDF", "pdf-ia": "Lista PDF (IA)", lista: "Lista de precios" };

export default function ProductPriceHistory({ productId }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get(`/products/${productId}/price-history`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [productId]);

  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-3" data-testid="product-price-history">
      <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">
        <History className="w-3.5 h-3.5" /> Historial de precios
      </div>
      {items === null && <p className="text-xs text-slate-400">Cargando...</p>}
      {items && items.length === 0 && <p className="text-xs text-slate-400" data-testid="price-history-empty">Sin cambios de precio registrados todavía.</p>}
      {items && items.length > 0 && (
        <ul className="space-y-1.5 max-h-40 overflow-auto">
          {items.map((h) => (
            <li key={h.id} className="flex items-center gap-2 text-xs" data-testid={`price-history-item-${h.id}`}>
              <span className="text-slate-500 w-[88px] flex-shrink-0">{new Date(h.created_at).toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit", year: "2-digit" })}</span>
              <span className="text-slate-500">{formatARS(h.old_price)}</span>
              <ArrowRight className="w-3 h-3 text-slate-300" />
              <span className="font-semibold text-slate-800">{formatARS(h.new_price)}</span>
              <span className={`font-semibold ${h.pct > 0 ? "text-red-600" : "text-green-600"}`}>{h.pct === null ? "" : `${h.pct > 0 ? "+" : ""}${h.pct}%`}</span>
              <span className="ml-auto text-slate-400 truncate max-w-[140px]" title={h.filename || ""}>{h.filename || SOURCE_LABEL[h.source] || h.source}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
